import React from 'react';
import './Space.css';

const Space = ({space}) => {
    return (
        <div style={{height: `${space}px`}} className={"Space"}>

        </div>
    );
};

export default Space;